import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ErrorList2 } from 'Components/ComponentLibrary/Molecules/ErrorList2';
import { FDFacetLogo, FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMobileLayout from 'Hooks/useMobileLayout';
import { dataAttrs } from 'Helpers/Testing';

const useStyles = buildUseStyles('AuthenticationLayoutForm', (theme) => ({
  root: {
    width: '100%',
  },
  rootDesktop: {
    padding: theme.spacing(8),
    maxWidth: 500,
  },
  rootMobile: {
    padding: theme.spacing(8, 4),
    maxWidth: 'min(100vw, 500px)',
  },
}));

export const AuthenticationLayoutForm = ({
  id,
  onSubmit,
  children,
  errors,
}) => {
  const isMobile = useMobileLayout();
  const classes = useStyles();
  return (
    <form
      className={classNames(classes.root, {
        [classes.rootDesktop]: !isMobile,
        [classes.rootMobile]: isMobile,
      })}
      {...dataAttrs(id)}
      id={id}
      onSubmit={(evt) => {
        evt.preventDefault();
        onSubmit();
      }}
    >
      <FDStack direction={'column'} spacing={4} alignItems={'stretch'}>
        <FDFacetLogo size={'lg'} alignSelf={'flex-start'} />
        <MetaControlField attr={'title'} />
        <MetaControlField attr={'subtitle'} />
        <MetaControlField attr={'message'} />
        <ErrorList2 errors={errors} />
        {children}
        <MetaControlField attr={'disclosure'} />
        <button type={'submit'} hidden />
      </FDStack>
    </form>
  );
};

AuthenticationLayoutForm.defaultProps = {
  errors: [],
};

AuthenticationLayoutForm.propTypes = {
  id: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  errors: PropTypes.array,
};
